// TODO: look for other places to use this
export default function getBoardLink(
  boardId: string,
  manufacturingPanel?: boolean,
  shipmentId?: string,
) {
  if (manufacturingPanel) {
    const shipmentQuery = shipmentId ? `&shipmentId=${shipmentId}` : "";
    return `/review-board/${boardId}?view=Manufacturing&manufacturingPanelView=Inventory${shipmentQuery}`;
  }
  return `/review-board/${boardId}`;
}
